import * as z from 'zod';

import { percentageInput } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { categoryUpdateSchema } from './category-mutation-schema';
import { categoryQueryLinkerSchema } from './category-query-linker-schema';

export const categoryFormSchema = categoryUpdateSchema
  .omit({
    name: true,
    status: true,
    parent_id: true,
    sku_prefix: true,
  })
  .extend({
    name: z.string().min(3),
    sku_prefix: z.string().min(2),
    status: statusFormSchema,
    parent: categoryQueryLinkerSchema.nullable(),
    wholesale_discount: percentageInput.formSchema(),
  });

export type CategoryFormSchema = z.infer<typeof categoryFormSchema>;
